import { render, staticRenderFns } from "./BettingResults.vue?vue&type=template&id=d7aa05c8&"
import script from "./BettingResults.vue?vue&type=script&lang=js&"
export * from "./BettingResults.vue?vue&type=script&lang=js&"
import style0 from "./BettingResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports